import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FaUniversity,
  FaHandHoldingUsd,
  FaCoins,
  FaShieldAlt,
  FaExchangeAlt,
  FaFingerprint,
} from "react-icons/fa";

function Services() {
  const services = [
    {
      name: "Savings Accounts",
      description:
        "Securely manage your finances with our range of savings account options tailored to your needs.",
      icon: <FaUniversity className="text-5xl" />,
      link: "/savings-accounts", // Replace with actual link
    },
    {
      name: "Gold Loan Services",
      description:
        "Unlock the value of your gold assets with our hassle-free gold loan services, offering quick and easy access to funds.",
      icon: <FaCoins className="text-5xl" />,
      link: "/gold-loans", // Replace with actual link
    },
    {
      name: "Micro ATM (Card Swipe)",
      description:
        "Conduct convenient banking transactions, including cash withdrawals and deposits, using our Micro ATM card swipe facility.",
      icon: <FaHandHoldingUsd className="text-5xl" />,
      link: "/micro-atm", // Replace with actual link
    },
    {
      name: "AEPS",
      description:
        "Access your bank account and perform transactions securely using your Aadhaar number and biometric authentication through our AEPS service.",
      icon: <FaFingerprint className="text-5xl" />,
      link: "/aeps", // Replace with actual link
    },
    {
      name: "Fino Money Transfer",
      description:
        "Transfer funds instantly and securely to any bank account in India with our Fino Domestic Money Transfer service.",
      icon: <FaExchangeAlt className="text-5xl" />,
      link: "/fino-domestic-money-transfer", // Replace with actual link
    },
    {
      name: "Life Insurance",
      description:
        "Protect your loved ones and secure their financial future with our comprehensive life insurance plans.",
      icon: <FaShieldAlt className="text-5xl" />,
      link: "/life-insurance", // Replace with actual link
    },
  ];

  // Framer Motion Variants for Card Animation
  const cardVariants = {
    offscreen: {
      y: 50,
      opacity: 0,
    },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 0.8,
      },
    },
  };

  return (
    <section id="services" className="py-20 md:py-28 px-4 md:px-8 bg-blue-50">
      <div className="container mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Comprehensive Financial Solutions
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            From basic banking to specialized investments, we offer a spectrum
            of services to help you achieve your financial goals.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {services.map((service, index) => (
            <motion.div
              key={service.name}
              className="bg-white p-6 md:p-8 rounded-xl shadow-lg flex flex-col items-center  group" // Added group for icon hover
              variants={cardVariants}
              initial="offscreen"
              whileInView="onscreen"
              viewport={{ once: true, amount: 0.2 }}
              whileHover={{ scale: 1.05 }} //scale effect for card
            >
              <div className="mb-6 text-blue-600 group-hover:text-blue-500">
                {service.icon}
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                {service.name}
              </h3>
              <p className="text-gray-600 text-center mb-6">
                {service.description}
              </p>
              <Link
                to={service.link}
                className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-full transition duration-300 ease-in-out mt-auto"
              >
                Learn More
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;